import { externalUploadPoller } from '@ff-os/pdp-shared-redux/apis/external-upload/externalUploaderPoller';
import { PhotoPrintsPdpStore } from '@ff-scene-plugins/photo-prints-redux/store';
import { createExternalUploadPollListener } from '../thunks/photoPrintsPollHandler';
import { startBlobStoreGarbageCollector } from './startBlobUrlGarbageCollector';
import { subscribe } from './subscriptions';

export const startup = (store: PhotoPrintsPdpStore) => {
    subscribe(store);
    externalUploadPoller.addPollListener(createExternalUploadPollListener(store));
    startBlobStoreGarbageCollector(store);
};